import React from "react";
import { Button, Card, DatePicker, Form } from "antd";
import { Col, Row } from "react-bootstrap";
import { MdFileDownload } from "react-icons/md";
import PageHeader from "../../Routes/PageHeader";
import "./style.css";

const BalanceSheet = () => {
  const tableData = {
    liabilities: [
      { name: "CURRENT LIABILITIES", amount: 0, isHeader: true },
      { name: "GST PAYABLE", amount: 0 },
      { name: "FUTURE LIABILITY", amount: 0 },
      { name: "CAPITAL", amount: 0 },
      { name: "Profit And Loss", amount: 0 },
      { name: "TOTAL LIABILITIES", amount: "NaN", isTotal: true },
    ],
    assets: [
      { name: "CURRENT ASSETS", amount: 0, isHeader: true },
      { name: "GST RECEIVABLE", amount: 0 },
      { name: "FUTURE ASSETS", amount: 0 },
      { name: "FIXED ASSETS", amount: 0 },
      { name: "", amount: "" },
      { name: "TOTAL ASSETS", amount: "NaN", isTotal: true },
    ],
  };

  return (
    <div className="container">
      <PageHeader
        PageName="Balance Sheet"
        breadScrum="Dashboard > Report > Balance Sheet"
      />

      <Form className="form-container">
        <Row>
          <Col md={8} />
          <Col className="flex-end">
            <Button
              className="download-button"
              icon={<MdFileDownload size={20} />}
            />
          </Col>
          <Col>
            <Form.Item>
              <DatePicker className="date-picker-container" />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Card className="card-container">
        <div className="card-title">
          BALANCE SHEET AS ON <strong>2025-01-28</strong>
        </div>

        <div className="table-container">
          <table className="table">
            <thead>
              <tr className="table-header">
                <th className="header-cell">LIABILITY</th>
                <th className="header-cell">AMOUNT ( INR )</th>
                <th className="header-cell">ASSETS</th>
                <th className="header-cell">AMOUNT ( INR )</th>
              </tr>
            </thead>
            <tbody>
              {tableData.liabilities.map((row, index) => (
                <tr key={index}>
                  <td
                    className={`table-cell ${row.isHeader ? "bold-text" : ""}`}
                  >
                    {row.name}
                  </td>
                  <td
                    className={`table-cell ${row.isTotal ? "bold-text" : ""}`}
                  >
                    {row.amount}
                  </td>
                  <td
                    className={`table-cell ${
                      tableData.assets[index].isHeader ? "bold-text" : ""
                    }`}
                  >
                    {tableData.assets[index].name}
                  </td>
                  <td
                    className={`table-cell ${
                      tableData.assets[index].isTotal ? "bold-text" : ""
                    }`}
                  >
                    {tableData.assets[index].amount}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default BalanceSheet;
